import { useState } from "react";
import { faqItems } from "@/mocks/faq";

export default function FAQSection() {
  const [openIndex, setOpenIndex] = useState<number | null>(null);

  const toggleFAQ = (index: number) => {
    setOpenIndex(openIndex === index ? null : index);
  };

  return (
    <section id="faq" className="relative w-full py-16 md:py-20 bg-background-100">
      <div className="max-w-3xl mx-auto px-4 md:px-6">
        <div className="text-center mb-10">
          <span className="inline-block px-4 py-1.5 bg-secondary-100 text-secondary-800 text-xs font-medium rounded-full mb-4">
            FAQ
          </span>
          <h2 className="font-heading text-2xl md:text-4xl font-bold text-foreground-900 mb-3">
            Często zadawane pytania
          </h2>
          <p className="text-sm md:text-base text-foreground-600">
            Wszystko, co musisz wiedzieć o USFansSpreadsheet
          </p>
        </div>

        <div className="space-y-3">
          {faqItems.map((item, i) => (
            <div
              key={i}
              className="bg-background-50 border border-background-200/70 rounded-xl overflow-hidden"
            >
              <button
                onClick={() => toggleFAQ(i)}
                className="w-full flex items-center justify-between px-5 py-4 text-left cursor-pointer hover:bg-background-100/50 transition-colors"
                aria-expanded={openIndex === i}
              >
                <h3 className="text-sm md:text-base font-semibold text-foreground-800 pr-4">
                  {item.question}
                </h3>
                <div className={`w-6 h-6 flex items-center justify-center flex-shrink-0 transition-transform duration-200 ${openIndex === i ? "rotate-45" : ""}`}>
                  <i className="ri-add-line text-foreground-500 text-lg"></i>
                </div>
              </button>
              <div
                className={`overflow-hidden transition-all duration-300 ${
                  openIndex === i ? "max-h-96" : "max-h-0"
                }`}
              >
                <p className="px-5 pb-4 text-sm md:text-base text-foreground-600 leading-relaxed">
                  {item.answer}
                </p>
              </div>
            </div>
          ))}
        </div>

        <div className="mt-10 text-center">
          <LinkToMain />
        </div>
      </div>

      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{
          __html: JSON.stringify({
            "@context": "https://schema.org",
            "@type": "FAQPage",
            mainEntity: faqItems.map((item) => ({
              "@type": "Question",
              name: item.question,
              acceptedAnswer: {
                "@type": "Answer",
                text: item.answer,
              },
            })),
          }),
        }}
      />
    </section>
  );
}

function LinkToMain() {
  return (
    <a
      href="https://kaspreadsheet.com/"
      target="_blank"
      rel="noopener nofollow"
      className="inline-flex items-center gap-2 px-6 py-3 bg-primary-500 text-background-50 text-sm font-semibold rounded-full hover:bg-primary-600 transition-colors whitespace-nowrap cursor-pointer"
    >
      Przejdź do kaspreadsheet.com
      <i className="ri-arrow-right-up-line text-base"></i>
    </a>
  );
}